import React from "react";
import { MapPin, Phone } from "lucide-react";

const showrooms = [
  {
    id: 1,
    city: "Gajuwaka",
    address: "26-15-1, Chaitanya Nagar, Gajuwaka, Visakhapatnam, Andhra Pradesh 530026",
    phone: "+91 98765 43210",
    image: "https://images.unsplash.com/photo-1541888069-4217117173e1?auto=format&fit=crop&q=80&w=600",
    mapLink: "#"
  },
  {
    id: 2,
    city: "Vizag (MVP Colony)",
    address: "Sector-3, MVP Double Rd, MVP Colony, Visakhapatnam, Andhra Pradesh 530017",
    phone: "+91 98765 01234",
    image: "https://images.unsplash.com/photo-1581452932331-5f00a6e00cae?auto=format&fit=crop&q=80&w=600",
    mapLink: "#"
  }
];

const Showrooms = () => {
  return (
    <div className="w-full bg-[#fdfaf5] py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-serif text-[#D4AF37] mb-3">
            Visit Our Showrooms
          </h2>
          <p className="text-gray-500 text-sm uppercase tracking-widest">
            Experience our curated collections in person
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12">
          {showrooms.map((store) => (
            <div key={store.id} className="bg-white border border-[#eae0d5] flex flex-col md:flex-row shadow-sm hover:shadow-md transition-shadow h-full">
              
              {/* Left Image */}
              <div className="w-full md:w-2/5 h-48 md:h-auto overflow-hidden">
                <img 
                  src={store.image} 
                  alt={`${store.city} Showroom`} 
                  className="w-full h-full object-cover transition-transform duration-700 hover:scale-110"
                />
              </div>

              {/* Right Content */}
              <div className="w-full md:w-3/5 p-6 flex flex-col justify-center">
                <div className="bg-[#D4AF37] text-black text-xs font-bold uppercase tracking-wider py-1 px-3 inline-block self-start mb-4">
                  Flagship Store
                </div>
                
                <h3 className="text-2xl font-serif text-[#3B291A] mb-4">{store.city}</h3>
                
                <div className="flex items-start gap-3 mb-3">
                  <MapPin className="w-5 h-5 text-[#D4AF37] shrink-0 mt-0.5" />
                  <p className="text-gray-600 text-sm leading-relaxed">{store.address}</p>
                </div>
                
                <div className="flex items-center gap-3 mb-6">
                  <Phone className="w-5 h-5 text-[#D4AF37] shrink-0" />
                  <p className="text-gray-600 text-sm font-medium">{store.phone}</p>
                </div>

                <a 
                  href={store.mapLink}
                  className="text-sm font-semibold text-[#D4AF37] border-b-2 border-[#D4AF37] pb-1 self-start hover:text-[#B8982D] hover:border-[#B8982D] transition-colors"
                >
                  Get Directions
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Showrooms;
